export default __webpack_public_path__ + "static/media/center-logo.fd11fc2e.svg";